var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table table-fit table-borderless table-hover mb-0"},[_c('tbody',_vm._l((_vm.clients),function(client){return _c('search-client-table-row',{key:client.id,attrs:{"client":client}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }